/* eslint-disable no-nested-ternary */
import { useEffect, useState } from 'react';

import { useSensor } from '@powdr/hooks';

export const useWindSpeedMeasurement = (sensor, sensorLocation) => {
  if (!sensor && !sensorLocation) return null;

  const sensorData = useSensor(sensor, sensorLocation);
  const [windSpeedData, setWindSpeedData] = useState(null);

  useEffect(() => {
    if (sensorData?.wind?.low || sensorData?.wind?.high || sensorData?.wind?.direction) {
      setWindSpeedData({
        low: sensorData?.wind?.low,
        high: sensorData?.wind?.high,
        direction: sensorData?.wind?.direction,
      });
    }
  }, [sensorData]);

  return windSpeedData;
};
